//Use this only in addition to control service to keep it clean.

import { Injectable } from '@angular/core';
import { Navigator } from '../routing/navigator';
import { UserSessionService } from '../user-session/user-session.service';
import { EventsService } from '../event/event.service';
import { WebcontentService } from '../webcontent/webcontent.service';
import { BannerInterface, CategoryInterface } from 'src/app/interfaces/lobby.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ControlHelperService {

  //Note: Use this only in addition to control service to keep it clean.
  private activeCategoryLobbySubject = new BehaviorSubject<CategoryInterface | null>(null);
  public activeLobbyCategory$ = this.activeCategoryLobbySubject.asObservable();
  private lastActiveCategoryLobbySubject = new BehaviorSubject<CategoryInterface | null>(null);
  public lastActiveLobbyCategory$ = this.lastActiveCategoryLobbySubject.asObservable();

  constructor(
    private events: EventsService,
    private navigator: Navigator,
    private userSession: UserSessionService,
    private webContent: WebcontentService
  ) { }

  private get isAuthenticated(): boolean {
    return this.userSession.isAuthenticated();
  }

  public controlNavigateTo(route): any {
    if (!route) console.warn('[Control Service: controlNavigateTo] Route not found: ', route);
    const allowedRoutes = ['LoginComponent', 'SignupStepOneComponent']

    if (allowedRoutes.includes(route)) return this.navigator.navigateTo(route);
    if (this.isAuthenticated) return this.navigator.navigateTo(route, { mulmultipleModals: false });

    console.log('[Control Service: controlNavigateTo] User not authenticated, redirecting to' + route);
    this.navigator.setWaitingModal(route);
    return this.navigator.navigateTo('LoginComponent');
  }

  public controlOpenWebview(route: any) {
    if (!route) console.warn('[Control Service: controlOpenWebview] Route not found: ', route);
    this.webContent.updateWebcontentLink(route);
    this.events.publish("event:reload:externallinks");
  }

  public onAlert(category: CategoryInterface): any {
    const popoverComp = 'PopoverAlertComponent';

    const data: any = {
      content: `Please configure this category properly name: ${category.name}, id: ${category.id}, id: ${category.action_type}, action_param: ${category.action_param}.`
    };

    return this.navigator.openPopover(popoverComp, data);
  }

  public onBannerAlert(item: BannerInterface): any {
    const popoverComp = 'PopoverAlertComponent';

    const data: any = {
      content: `Please configure this banner properly. Name: ${item.name}, ID: ${item.id}, Action Type: ${item.actionType}. We are not supporting ${item.actionType} at the moment.`
    };

    return this.navigator.openPopover(popoverComp, data);
  }

  //Store Lobbyplacement category from all 3 NavBar, top, center, bottom
  public setActiveLobbyCategory(category: CategoryInterface) {
    this.activeCategoryLobbySubject.next(category);
  }

  public setLastActiveLobbyCategory(category: CategoryInterface) {
    this.lastActiveCategoryLobbySubject.next(category);
  }

}

//Please Read Comments at Top
